<span class="mention" [matMenuTriggerFor]="menu"
  >{{ mentionSymbol }}{{ key }}</span
>
<mat-menu #menu="matMenu">
  <ng-container #containerRef />
</mat-menu>
